import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantsCLA } from '../../../shared/constants-cla';
import { SearchLogOperazioneCommand } from '../../../model/command-model';
import { ListLogOperazioneDTO } from 'src/app/model/newModel';
import { SelectDTO } from '../../../model/newModel';

@Injectable({
  providedIn: 'root',
})
export class LogOperazioneService {
  constructor(private http: HttpClient) {}

  search(idUtente: string, idTipoOperazione: string) {
    const command = new SearchLogOperazioneCommand();
    command.skip = 0;
    command.take = 10;
    command.idUtente = Number(idUtente);
    command.idTipoOperazione = idTipoOperazione;
    return this.http.post<ListLogOperazioneDTO>(
      ConstantsCLA.SEARCH_LOG_OPERAZIONE_URL,
      command
    );
  }

  previousPage(
    idUtente: string,
    idTipoOperazione: string,
    skip: number,
    take: number
  ) {
    const skipNew = skip - 1 < 0 ? 0 : skip - 1;
    const command = new SearchLogOperazioneCommand();
    command.skip = skipNew;
    command.take = take;
    command.idUtente = Number(idUtente);
    command.idTipoOperazione = idTipoOperazione;
    return this.http.post<ListLogOperazioneDTO>(
      ConstantsCLA.SEARCH_LOG_OPERAZIONE_URL,
      command
    );
  }

  nextPage(
    idUtente: string,
    idTipoOperazione: string,
    skip: number,
    take: number,
    count: number
  ) {
    const skipNew = skip + 1;
    const command = new SearchLogOperazioneCommand();
    command.skip = skipNew;
    command.take = take;
    command.idUtente = Number(idUtente);
    command.idTipoOperazione = idTipoOperazione;
    return this.http.post<ListLogOperazioneDTO>(
      ConstantsCLA.SEARCH_LOG_OPERAZIONE_URL,
      command
    );
  }

  goToPage(
    idUtente: string,
    idTipoOperazione: string,
    idVaiA: string,
    take: number
  ) {
    const command = new SearchLogOperazioneCommand();
    command.skip = Number(idVaiA);
    command.take = take;
    command.idUtente = Number(idUtente);
    command.idTipoOperazione = idTipoOperazione;
    return this.http.post<ListLogOperazioneDTO>(
      ConstantsCLA.SEARCH_LOG_OPERAZIONE_URL,
      command
    );
  }

  getTipoOperazione(): SelectDTO[] {
    const tipiOperazione: SelectDTO[] = [];

    const OPERAZIONE_CREAZIONE = new SelectDTO();
    OPERAZIONE_CREAZIONE.value = 'CREAZIONE';
    OPERAZIONE_CREAZIONE.viewValue = 'CREAZIONE';
    const OPERAZIONE_DOWNLOAD_AGENDA = new SelectDTO();
    OPERAZIONE_DOWNLOAD_AGENDA.value = 'DOWNLOAD AGENDA';
    OPERAZIONE_DOWNLOAD_AGENDA.viewValue = 'DOWNLOAD AGENDA';
    const OPERAZIONE_APPROVA_AGENDA = new SelectDTO();
    OPERAZIONE_APPROVA_AGENDA.value = 'APPROVA AGENDA';
    OPERAZIONE_APPROVA_AGENDA.viewValue = 'APPROVA AGENDA';
    const OPERAZIONE_CANCELLAZIONE = new SelectDTO();
    OPERAZIONE_CANCELLAZIONE.value = 'ELIMINAZIONE';
    OPERAZIONE_CANCELLAZIONE.viewValue = 'ELIMINAZIONE';
    const OPERAZIONE_MODIFICA = new SelectDTO();
    OPERAZIONE_MODIFICA.value = 'MODIFICA';
    OPERAZIONE_MODIFICA.viewValue = 'MODIFICA';
    const OPERAZIONE_APPELLO = new SelectDTO();
    OPERAZIONE_APPELLO.value = 'APPELLO';
    OPERAZIONE_APPELLO.viewValue = 'APPELLO';
    const OPERAZIONE_CARICAMENTO_DATI = new SelectDTO();
    OPERAZIONE_CARICAMENTO_DATI.value = 'CARICAMENTO';
    OPERAZIONE_CARICAMENTO_DATI.viewValue = 'CARICAMENTO';

    tipiOperazione.push(OPERAZIONE_APPELLO);
    tipiOperazione.push(OPERAZIONE_APPROVA_AGENDA);
    tipiOperazione.push(OPERAZIONE_CANCELLAZIONE);
    tipiOperazione.push(OPERAZIONE_CARICAMENTO_DATI);
    tipiOperazione.push(OPERAZIONE_CREAZIONE);
    tipiOperazione.push(OPERAZIONE_DOWNLOAD_AGENDA);
    tipiOperazione.push(OPERAZIONE_MODIFICA);

    return tipiOperazione;
  }
}
